<template>
  <div>
    <com-dialog :visible.sync="visible" width="50%" title="审核">
      <el-descriptions title="提现信息" :column="1" v-if="type !== 'batch'">
        <el-descriptions-item label="提现金额">{{ info.amount }}</el-descriptions-item>
        <el-descriptions-item label="申请前充值金额">{{ info.beforeChargeSum }}</el-descriptions-item>
        <el-descriptions-item label="申请前赠送金额">{{ info.beforeGiveSum }}</el-descriptions-item>
        <!-- <el-descriptions-item label="冻结充值金">{{ info.userFreeze }}</el-descriptions-item>
        <el-descriptions-item label="冻结赠送金">{{ info.userFreezeGiveSum }}</el-descriptions-item> -->
      </el-descriptions>
      <div class="mt-15px">
        <el-descriptions title="审核结果" :column="1">
          <el-descriptions-item label="审核结果">
            <div class="flex items-center" style="height: 100%">
              <el-radio :disabled="type === 'detail'" v-model="form.auditStatus" label="1" @change="clearRefuseReason"
                >通过</el-radio
              >
              <el-radio :disabled="type === 'detail'" v-model="form.auditStatus" label="2" @change="clearRefuseReason"
                >拒绝</el-radio
              >
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="拒绝原因" v-if="form.auditStatus === '2'">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="form.refuseReason"
              :disabled="type === 'detail'"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="flex items-center justify-end">
        <el-button type="" @click="close">取消</el-button>
        <el-button type="primary" @click="submit" :disabled="type === 'detail'" :loading="loading">{{ loading ? '提交中' : '确认' }}</el-button>
      </div>
      <com-checked-pwd ref="checkPwd" @confirm="handleConfirm"></com-checked-pwd>
    </com-dialog>
  </div>
</template>

<script>
import { userWithdrawAudtitApi } from '@/api/finance'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      form: {},
      type: null,
      info: {},
      loading: false
    }
  },
  methods: {
    baseParams() {
      const params = {
        auditStatus: '',
        refuseReason: '',
        auditPassword: '',
        userWithdrawCodeList: []
      }
      return params
    },
    open(opt) {
      const { row, type, userWithdrawCodeList } = opt
      this.type = type
      this.form = this.baseParams()

      if (type === 'batch') {
        this.form.userWithdrawCodeList = userWithdrawCodeList
      } else {
        this.info = utils.deepCopy(row)
        this.form.userWithdrawCodeList = [row.code]

        this.form.auditStatus = this.info.auditStatus
        this.form.refuseReason = this.info.refuseReason
      }
      this.visible = true
    },
    close() {
      this.visible = false
    },
    submit() {
      console.log('this.type :>> ', this.type)
      if (this.type === 'detail') {
        this.close()
        return
      }

      if (!this.form.auditStatus) return this.$message.warning('请选择审核结果')
      this.$refs.checkPwd.open()
    },
    handleConfirm(val) {
      const params = { ...this.form, auditPassword: val }
      console.log('params :>> ', params)
      this.loading = true
      userWithdrawAudtitApi(params).then((res) => {
        if (res.status === 200) {
          this.$message.success('操作成功')
          this.$emit('success')
          this.loading = false
          this.close()
        } else {
          this.loading = false
        }
      })
    },
    // 清空拒绝原因
    clearRefuseReason() {
      this.form.refuseReason = ''
    }
  },
}
</script>
<style lang="scss">
.show_image {
  object-fit: contain;
  width: 150px;
  height: 150px;
}
</style>
